export const types = {
  VEHICLE_PLACEMENT_DETAIL_REPORT: "VEHICLE_ANALYSIS_REPORT",
  VEHICLE_PLACEMENT_DETAIL_REPORT_SUCCESS: "VEHICLE_ANALYSIS_REPORT_SUCCESS",
  VEHICLE_PLACEMENT_DETAIL_REPORT_FOR_EXCEL:
    "VEHICLE_ANALYSIS_REPORT_FOR_EXCEL",
  VEHICLE_PLACEMENT_DETAIL_REPORT_FOR_EXCEL_SUCCESS:
    "VEHICLE_ANALYSIS_REPORT_FOR_EXCEL_SUCCESS",
};
